import axios from 'axios';

export default {
	sendEmailsByMonth(month) {
		return axios.post(`/api/statistics/report?month=${month}`);
	},
	sendEmailToUserByMonth(month, id) {
		return axios.post(`/api/statistics/report/user/${id}?month=${month}`);
	},
	getDrivers() {
		return axios.get(`/api/users?sort=lastName`);
	},
	loadStatistics(from, to, users) {
		return axios.post('/api/statistics', { from, to, users: users });
	},
};
